import styled from 'styled-components';

import { Layer } from 'ui/utility/layer';
import { CollapseStateContextProvider } from './context/CollapseStateContextProvider';

import { ContextProps, TreeViewContextProvider } from './context/TreeViewContextProvider';
import { BranchFocusContextProvider } from './context/BranchFocusContextProvider';
import { TreeRoot, TreeRootProps } from './TreeRoot';

export type NestedTableViewProps = Omit<ContextProps, 'identifier' | 'highlight' | 'sort'> &
  TreeRootProps & {
    storageKey?: string;
  };

const NestedTableViewContainer = styled.div`
  position: relative;
`;

export const NestedTableView = ({
  collapseByDefault = true,
  storageKey = 'generic',
  src,
  tableColor,
  altRowColorDepth,
  showBranchFocus = false,
}: NestedTableViewProps) => {
  return (
    <TreeViewContextProvider
      {...{
        collapseByDefault,
        tableColor,
        altRowColorDepth,
        showBranchFocus,
        isNestedTable: true,
      }}
    >
      <CollapseStateContextProvider identifier={storageKey} src={src}>
        <BranchFocusContextProvider>
          <NestedTableViewContainer>
            <Layer $priority={1}>
              <TreeRoot src={src} />
            </Layer>
          </NestedTableViewContainer>
        </BranchFocusContextProvider>
      </CollapseStateContextProvider>
    </TreeViewContextProvider>
  );
};
